import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import withStyles from 'utils/withStyles';
import styles from './style';
import messages from './messages';
import { getConfigValue } from 'utils/commonUtils';
import {
  loadItem,
  loadItemInProd,
  saveItem,
} from '../../../services/localStorageApi';
const originUrl = window.location.origin;
// Kept on v1 while the v1 and v2 login pages coexist (see the top-bar logout
// binding in Cap.js, PR #467). Flip back to 'new_login_url' once v1 is
// deprecated.
const loginUrl = getConfigValue('login_url');

export const RedirectToLoginPage = ({ className, intl: { formatMessage } }) => {
  useEffect(() => {
    setTimeout(() => {
      const isLoggedInPresent =
        process.env.NODE_ENV === 'production'
          ? loadItemInProd('isLoggedIn')
          : loadItem('isLoggedIn');
      if (!isLoggedInPresent) saveItem('isLoggedIn', true);
      window.location = `${originUrl}${loginUrl}`;
    }, 1500);
  }, []);
  return (
    <div className={className}>
      <div className="redirect-login-page">
        <div className="header">{formatMessage(messages.header)}</div>
        <div className="message">
          <div>{formatMessage(messages.message)}</div>
          <div>{formatMessage(messages.loginAgainMessage)}</div>
        </div>
      </div>
    </div>
  );
};

RedirectToLoginPage.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  className: PropTypes.string,
};

export default injectIntl(withStyles(RedirectToLoginPage, styles));
